import React, { useState, MouseEvent } from 'react';
import { HIDE_MOBILE_APP, REF_COOKIE } from 'constants/cookie';
import { Box, Checkbox, Flex } from '@igooods/ui-kit';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import { colors } from 'constants/colors';
import Link from 'Components/Link/LinkWrapper';
import { URL } from 'constants/urlMaps';
import Logo from 'Components/Header/Logo';
import Text from 'Components/Typography/Text';
import { FontFamily, FontWeight } from 'theme';
import android from 'assets/images/google-play.svg';
import appstore from 'assets/images/app-store.svg';
import { useUserAgentContext } from 'utils/userAgent/context';
import back from './assets/back.png';
import analyticsManager from 'utils/tagManager/manager';
import { useHistory } from 'react-router';
import { TLocationState } from 'configureHistory';
import { EnumGtagEvents } from 'constants/enums';
import { Helmet } from 'react-helmet';
import { seo } from 'seo.config';
import { metaPageDescription } from 'constants/constants';

const Container = styled(Flex).attrs({ column: true })`
  height: 100%;
  max-width: 1440px;
  margin: 0 auto;
  background-color: ${colors.lightGreyGreenThree};
`;

const Header = styled(Flex).attrs({ middle: true })`
  border-bottom: 1px solid rgba(0, 75, 70, 0.2);
  padding: 0 17px;
  height: 47px;
`;

const Footer = styled.div`
  background-color: ${colors.white};
  padding: 11px 17px 9px;
`;

const Content = styled.div`
  padding: 32px 17px;
  flex-grow: 1;
  text-align: center;
  background-image: url(${back});
  background-repeat: no-repeat;
  background-position: center bottom -85px;
  background-size: auto calc(100% - 150px);
`;

const StoreImg = styled.img`
  width: 135px;
`;

const StoreLink = styled.div`
  & + & {
    margin-left: 10px;
  }
`;

// на лендосе не предусмотрен адаптив текста заголовка, поэтому параметры шрифта фиксированные
const Heading = styled(Text)`
  font-size: 18px;
  line-height: 22px;
`;

const ContinueLink = styled(Text)`
  font-size: 12px;
  line-height: 22px;
`;

export const getAppMetrikaLinkWithRef = (link: string): string => {
  const ref = Cookies.get(REF_COOKIE);
  return ref ? `${link}?referral_name=${ref}` : link;
};

const MobileApp = () => {
  const [checked, setChecked] = useState(Cookies.get(HIDE_MOBILE_APP) === 'true');
  const { isIOS, isAndroid } = useUserAgentContext();
  const history = useHistory<TLocationState>();

  const handleClick = (val: boolean) => {
    setChecked(val);
    Cookies.set(HIDE_MOBILE_APP, Boolean(val).toString());
  };

  const handleLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    analyticsManager.gtag('click', {
      event_category: 'links',
      event_label: 'tomobileweb',
    });
    /**
     * после попадания на эту страницу и клике по ссылке мы берем локейшн, который приходит в стейте
     * чтобы средиректить нуда, куда пользователь хотел перейти. Либо на селек аддресс.
     */
    const locationToRedirect = history.location.state?.prev || { pathname: e.currentTarget.pathname };
    history.replace({ ...locationToRedirect, state: undefined });
  };

  const handleStoreLink = () => {
    analyticsManager.gtag(EnumGtagEvents.CLICK_MOBILE_DOWNLOAD, { type: 'old' });
    window.open(getAppMetrikaLinkWithRef(URL.mobile_appmetrica), '_blank');
  };

  return (
    <>
      <Helmet>
        <title>{seo.mobileApp.pageTitle}</title>
        <meta content={metaPageDescription} name="description" />
        <meta content={seo.mobileApp.pageTitle} name="og:title" />
        <meta content={metaPageDescription} name="og:description" />
      </Helmet>
      <Container>
        <Header>
          <Logo />
        </Header>
        <Content>
          <Box mb={6}>
            <Heading fontWeight={FontWeight.bold} fontFamily={FontFamily.secondFont} color={colors.black}>
              С мобильным приложением удобнее
            </Heading>
          </Box>
          <Box mb={6}>
            {isIOS && (
              <StoreLink onClick={handleStoreLink}>
                <StoreImg src={appstore} />
              </StoreLink>
            )}
            {isAndroid && (
              <StoreLink onClick={handleStoreLink}>
                <StoreImg src={android} />
              </StoreLink>
            )}
          </Box>
          <Link to={URL.select_address} onClick={handleLinkClick}>
            <ContinueLink color={colors.darkBlueGreen}>Закрыть и перейти на сайт</ContinueLink>
          </Link>
        </Content>
        <Footer>
          <Checkbox checked={checked} label="Больше не показывать" name="not_show" onChange={handleClick} />
        </Footer>
      </Container>
    </>
  );
};

export default MobileApp;
